import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Navigator from '../Navigator'

import '../../styles/BlowoutMenuItem.css'

class BlowoutMenuItem extends Component {
  render () {
    const {
      history,
      data
    } = this.props

    const {
      titleOverride,
      item
    } = data

    const title = titleOverride || item.title

    console.log(this.props)

    let featureImage

    if (data.item.featureImage) {
      featureImage = data.item.featureImage
    } else {
      featureImage = data.featureImage
    }

    return (
      <div className='BlowoutMenuItem'>
        <Navigator type={data.menuableType} id={data.menuableId} history={history}>
          <div className='jumplink' style={{backgroundImage: 'url(' + featureImage + ')'}}>
            <div className='jumplink-content'>{title}</div>
            <div className='overlay primary-1' />
          </div>
        </Navigator>
      </div>
    )
  }
}

BlowoutMenuItem.propTypes = {
  data: PropTypes.object,
  history: PropTypes.object
}

export default BlowoutMenuItem



// WEBPACK FOOTER //
// ./src/components/menus/BlowoutMenuItem.js